export enum FaxStatus {
  Processing = "Processing",
  TelnyxProcessing = "TelnyxProcessing",
  Success = "Success",
  Failed = "Failed",
}
